import React, { useLayoutEffect, useState } from "react";
import { Blurhash } from "react-blurhash";

import Coach from "../Components/Reuseable/Coach";
import image from "../assets/images/group/coach.jpg";
import { useGlobalContext } from "../Context";

const coachHeaderHash = "L#I=.iWBxZWB~UWDR*j]^#ofWWj?";

export default function Coaches() {
  const { setNav, coach } = useGlobalContext();
  const [loaded, setLoaded] = useState(false);

  // console.log(loaded);
  // Function to handle image load event
  const handleImageLoad = () => {
    setLoaded(true);
  };

  useLayoutEffect(() => {
    setNav(true);
    document.title = "Beyond Limits Football Academy - Coaches";
  }, [setNav]);
  return (
    <>
      <header>
        {!loaded && (
          <div
            // style={{ width: "100%", height: "100%" }}
            className="Coaches"
          >
            <Blurhash
              hash={`${coachHeaderHash}`}
              width="100%"
              height="100%"
              resolutionX={32}
              resolutionY={32}
              punch={1}
            />
          </div>
        )}
        <img
          src={image}
          alt="coaches"
          className={`${loaded?"block": "hidden"} Coaches`}
          onLoad={handleImageLoad}
        />
      </header>

      <section className="Coach">
        <div className="container">
          <div className="Coach__Staff">
            <p className="Players__title Staff__title">
              beyond limits football academy coaches
            </p>
            <p className="Coach__text">
              Beyond Limits Football Academy uses skilled and experienced
              coaches. We want a profile with ambitious coaches great academic
              weight for our projects. The coaches are carefully selected from
              applications we receive and our existing contact network.
            </p>
            <div className="row">
              {coach.map((item) => {
                return (
                  <div key={item._id} className="col-md-4">
                    <Coach item={item} />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
